import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

export const DUPR_LOGO = getCDNURL('https://images.pickleball.com/global/outside/DUPR.png', 132, 40);
export const DUPR_LOGO_WHITE = getCDNURL('https://images.pickleball.com/global/outside/DUPR_WHITE.svg', 132, 40);
export const DUPR_WIDTH = 66;
export const DUPR_HEIGHT = 20;
